import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportModalComponent } from 'src/app/shared/components/report-modal/report-modal.component';
import { PrescriptionStatusEnum } from 'src/app/shared/enum/prescription-status.enum';
import { PresentationEnum } from 'src/app/shared/enum/prescription.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { CallEpisodePrescriptionService } from 'src/app/shared/services/API/orchestrator-patient/call-episode-prescription.service';
import { LocationService } from 'src/app/shared/services/API/pharmacy/location.service';
import { MedicinePresentationTypeService } from 'src/app/shared/services/API/pharmacy/medicine-presentation-type.service';
import { VerifyStorageService } from 'src/app/shared/services/API/pharmacy/verify-storage.service';
import { LocationModel } from 'src/app/shared/services/models/pharmacy/location.model';
import { MedicinePresentationTypeModel } from 'src/app/shared/services/models/pharmacy/medicine-presentation-type.model';
import { LiberatePrescriptionRequest } from 'src/app/shared/services/requests/orchestrator-patient/liberate-prescription.request';
import { KitItemSelectStruct } from 'src/app/shared/services/structs/pharmacy/kit-item-select.struct';
import { StorageStruct } from 'src/app/shared/services/structs/pharmacy/storage.struct';
import { AlertModalComponent } from 'src/app/shared/components/alert-modal/alert-modal.component';
import { GetMedicineDataService } from 'src/app/shared/services/API/pharmacy/get-medicine-data.service';
import { KitService } from 'src/app/shared/services/API/pharmacy/kit.service';
import { AdditionalItemForPrescriptionReleaseFormStruct } from 'src/app/shared/services/structs/pharmacy/additional-item-for-prescription-release-form.struct';
import { AdditionalMedicineForPrescriptionReleaseFormStruct } from 'src/app/shared/services/structs/pharmacy/additional-medicine-for-prescription-release-form.struct';
import { AdditionalElementsToKitSearchRequest } from 'src/app/shared/services/requests/pharmacy/additional-elements-to-kit-search.request';
import { PrescriptionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine.struct';
import { EpisodeStruct } from 'src/app/shared/services/structs/medical-record/episode.struct';
import { LookupsBooleanChoiceRequest } from 'src/app/shared/services/requests/pharmacy/lookups-boolean-choice.request';
import { PharmacyLookupService } from 'src/app/shared/services/API/pharmacy/pharmacy-lookup.service';
import { MeasurementUnit } from 'src/app/shared/services/models/pharmacy/measurement-unit.model';
import { MedicineTagUtilsService } from 'src/app/shared/services/medicine-tag-utils.service';
import { DoseToAdministered } from 'src/app/shared/services/models/pharmacy/dose-to-administered.model';
import { MedicineBarCodeModalComponent } from '../medicine-bar-code-modal/medicine-bar-code-modal.component';
import { PresentationTypeConfirmModalComponent } from '../presentation-type-confirm-modal/presentation-type-confirm-modal.component';
import { PrescriptionNonDispensationModalComponent } from '../prescription-non-dispensation-modal/prescription-non-dispensation-modal.component';
import { AdditionalItemModalComponent } from '../additional-item-modal/additional-item-modal.component';
import { estoqueValidator } from '../../custom-validators/storage.validator';

@Component({
    selector: 'app-release-prescription-modal',
    templateUrl: './release-prescription-modal.component.html',
    styleUrls: ['./release-prescription-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReleasePrescriptionModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ReleasePrescriptionModalComponent>,
    public verifyStorageService: VerifyStorageService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    public locationService: LocationService,
    public callEpisodePrescriptionService: CallEpisodePrescriptionService,
    public medicinePresentationTypeService: MedicinePresentationTypeService,
    public kitService: KitService,
    public getMedicineDataService: GetMedicineDataService,
    public lookupService: PharmacyLookupService,
    public medicineTagUtilsService: MedicineTagUtilsService,
  ) { }

  public presentationOthersEnum: PresentationEnum = PresentationEnum.outros.valueOf();

  public listStorage: StorageStruct[];
  public listLocation: LocationModel[] = this.data.listLocation;
  public episode: EpisodeStruct = this.data.episode;
  public presentationList: MedicinePresentationTypeModel[];
  public measurementUnitList: MeasurementUnit[] = [];
  public listItemFields: KitItemSelectStruct[];
  public listPrescription: PrescriptionMedicineStruct[];
  public listAdditionalItemsForRequest: AdditionalItemForPrescriptionReleaseFormStruct[] = [];
  public listAdditionalMedicinesForRequest: AdditionalMedicineForPrescriptionReleaseFormStruct[] = [];
  public model: FormGroup;
  public prescriptionMedicineStruct: PrescriptionMedicineStruct;
  public storage: StorageStruct;
  public location: LocationModel;

  public isLoading: boolean;
  public validated: boolean;
  public isValid: boolean;
  public isInBulk: boolean = false;
  public isObservation: boolean = false;

  public barcodeValue: number;
  public idMedicinePresentationType: number;
  public quantityReleased: number;
  public indexPrescription: number;
  public progressDispensation: number = 0;
  public idSector: number;
  public idUserPharmacy: number;
  amountRemaining: number = null;
  public medicinePresentationOther: string = null;
  public quantityDoctor: string;
  public presentationTypeDoctor: string;
  listDoseToAdministered: DoseToAdministered[] = [];

  ngOnInit(): void {
    this.populatePharmacyLookups();

    if (this.data.isObservation) {
      this.isObservation = true;
      this.idSector = this.data.idSector;
    }
    if (this.data.prescription) {
      this.mapPrescription(this.data.prescription);
    }
    else if (this.data.listPrescription) {
      this.isInBulk = true;
      this.indexPrescription = 0;
      this.listPrescription = this.data.listPrescription;
      this.mapPrescription(this.listPrescription[this.indexPrescription]);
    }
  }

  mapPrescription(prescriptionMedicineStruct: PrescriptionMedicineStruct) {
    this.isLoading = true;
    this.prescriptionMedicineStruct = prescriptionMedicineStruct;
    this.listItemFields = [];
    this.validated = false;
    this.isValid = false;
    this.storageSuggestion();

    this.model = this.formBuilder.group({
      idLocation: [, [Validators.required]],
      quantity: ['', [Validators.required, Validators.min(0.001)]],
      idPresentationType: [{ value: '', disabled: true }],
      idMeasurementUnit: [{ value: this.prescriptionMedicineStruct.prescriptionMedicine.idMeasurementUnit, disabled: true }],
      tagsTooltipText: [{ value: '', disabled: true }],
      idDoseToAdministered: [{ value: this.prescriptionMedicineStruct.prescriptionMedicine.idDoseToAdministered, disabled: true }],
      calculatedTotalQuantity: [{ value: this.prescriptionMedicineStruct.prescriptionMedicine.calculatedTotalQuantity, disabled: true }],
    });

    if (this.data.isObservation) {
      this.location = this.listLocation.find(x => x.idSector === this.idSector);
      this.model.get('idLocation')?.setValue(this.location?.idLocation);
      this.model.get('idLocation')?.disable();
    }

    this.quantityDoctor = this.prescriptionMedicineStruct.prescriptionMedicine.quantity ? this.prescriptionMedicineStruct.prescriptionMedicine.quantity.toString() : "Não informado";
    this.quantityReleased = this.prescriptionMedicineStruct.quantityReleased ? this.prescriptionMedicineStruct.quantityReleased : 0;

    let quantityForPrescription = null;
    let calculatedQty = this.prescriptionMedicineStruct.calculatedDispensationQuantity;

    // O Input do formulário vai sugerir a quantidade calculada (ex: 1 comprimido em vez de 500mg)
    if (calculatedQty && this.prescriptionMedicineStruct.quantityReleased)
      quantityForPrescription = calculatedQty - this.prescriptionMedicineStruct.quantityReleased;
    else if (calculatedQty)
      quantityForPrescription = calculatedQty;
    this.model.get('quantity')?.setValue(quantityForPrescription ? quantityForPrescription.toString() : '');
    this.model.get('tagsTooltipText')?.setValue(prescriptionMedicineStruct ? prescriptionMedicineStruct.tagsTooltipText : '');

    if (prescriptionMedicineStruct?.listSelectedIdKit)
      this.getAdditionalElementsForDispenssing(prescriptionMedicineStruct?.listSelectedIdKit);
  }

  close() {
    this.matDialogRef.close({ checkMedicine: false });
  }

  submit() {
    if (!this.prescriptionMedicineStruct.patientHasAllergy) {
      this.liberatePrescription();
    }
    else {
      const dialogRef = this.dialog.open(AlertModalComponent, {
        data: {
          hasImage: true,
          isTwoButtonsModal: true,
          title: 'Atenção!',
          description: `O paciente é alérgico a um dos princípios ativos deste medicamento. \nDeseja prosseguir com a liberação?`
        },
      });
      dialogRef.afterClosed().subscribe({
        next: result => {
          if (result && result.confirm) {
            this.liberatePrescription();
          }
          this.isLoading = false;
        }
      });
    }
  }

  liberatePrescription() {
    this.model.get('idLocation')?.markAsTouched();
    this.model.get('quantity')?.markAsTouched();
    if (this.isLoading || this.model.invalid)
      return;

    if (!this.validateAdditionalItemsToSubmit() || !this.validateAdditionalMedicinesToSubmit()) {
      this.alertService.show('Erro', 'A quantidade solicitada do item é maior do que a disponível em estoque.', AlertType.error);
      return;
    }

    this.isLoading = true;

    let liberatePrescriptionRequest: LiberatePrescriptionRequest = new LiberatePrescriptionRequest();

    liberatePrescriptionRequest.idStorage = this.barcodeValue;
    liberatePrescriptionRequest.idMedicine = this.prescriptionMedicineStruct.prescriptionMedicine.idMedicine;
    liberatePrescriptionRequest.quantity = this.model.get('quantity')?.value ? parseFloat(this.model.get('quantity')?.value.replace(",", ".")) : null;
    liberatePrescriptionRequest.idLocation = this.model.get('idLocation')?.value;
    liberatePrescriptionRequest.dilutionName = this.prescriptionMedicineStruct.dilutionName;
    liberatePrescriptionRequest.medicineName = this.prescriptionMedicineStruct.medicineName;
    liberatePrescriptionRequest.administrationTypeName = this.prescriptionMedicineStruct.administrationTypeName;
    liberatePrescriptionRequest.patientName = this.episode.patientSocialName ? this.episode.patientSocialName : this.episode.patientName;
    liberatePrescriptionRequest.motherName = this.episode.motherName;
    liberatePrescriptionRequest.birthDate = this.episode.birthDate;
    liberatePrescriptionRequest.idEpisode = this.episode.idEpisode;
    liberatePrescriptionRequest.idUserPharmacy = this.idUserPharmacy;
    liberatePrescriptionRequest.idSector = this.idSector;
    //mudar esse request
    liberatePrescriptionRequest.idPrescriptionMedicine = this.prescriptionMedicineStruct.prescriptionMedicine.idPrescriptionMedicine;
    if (this.listAdditionalItemsForRequest && this.listAdditionalItemsForRequest.length > 0) {
      liberatePrescriptionRequest.listAdditionalItemForPrescriptionRelease = this.listAdditionalItemsForRequest.map(x => x.additionalItemForPrescriptionRelease);
    }
    if (this.listAdditionalMedicinesForRequest && this.listAdditionalMedicinesForRequest.length > 0) {
      liberatePrescriptionRequest.listAdditionalMedicineForPrescriptionRelease = this.listAdditionalMedicinesForRequest.map(x => x.additionalMedicineForPrescriptionRelease);
    }

    let totalQuantity = this.quantityReleased + liberatePrescriptionRequest.quantity;
    liberatePrescriptionRequest.idStatusPrescription = (this.prescriptionMedicineStruct.prescriptionMedicine.quantity &&
      (totalQuantity < this.prescriptionMedicineStruct.prescriptionMedicine.quantity)) ? PrescriptionStatusEnum.liberadoParcialmente : PrescriptionStatusEnum.Liberado;

    this.callEpisodePrescriptionService.liberatePrescription(liberatePrescriptionRequest).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.isLoading = false;
        this.alertService.show('Sucesso', "Prescrição liberada com sucesso!", AlertType.success);
        if (!this.isInBulk || (this.isInBulk && this.listPrescription.length == this.indexPrescription + 1))
          this.matDialogRef.close({ checkMedicine: true, newStatus: liberatePrescriptionRequest.idStatusPrescription });
        else {
          this.indexPrescription += 1;
          this.progressDispensation = (this.indexPrescription * 100) / this.listPrescription.length;
          this.mapPrescription(this.listPrescription[this.indexPrescription]);
        }

        if (response.isActive == true) {
          let reportDialog = this.dialog.open(ReportModalComponent, {
            data: {
              reportName: response.reportName,
              reportPdf64: response.reportPdf64,
            },
          });
        }
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  validateAdditionalItemsToSubmit(): boolean {
    if (!this.listAdditionalItemsForRequest?.length)
      return true;

    return this.listAdditionalItemsForRequest?.every(item => {
      var isValid = item.additionalItemForPrescriptionRelease?.idItem &&
        item.additionalItemForPrescriptionRelease?.idStorage &&
        item.additionalItemForPrescriptionRelease?.numberOfItens;

      return isValid;
    });
  }

  validateAdditionalMedicinesToSubmit(): boolean {
    if (!this.listAdditionalMedicinesForRequest?.length)
      return true;

    return this.listAdditionalMedicinesForRequest.every(medicine => {
      var isValid = medicine.additionalMedicineForPrescriptionRelease?.idMedicine &&
        medicine.additionalMedicineForPrescriptionRelease?.idStorage &&
        medicine.additionalMedicineForPrescriptionRelease?.numberOfItens;

      return isValid;
    });
  }

  clickCancel() {
    if (this.isInBulk) {
      const dialogRef = this.dialog.open(AlertModalComponent, {
        data: {
          isTwoButtonsModal: true,
          title: 'Atenção!',
          description: `Ainda existem ${this.listPrescription.length - this.indexPrescription} medicamento(s) que não foi/foram liberado(s). 
                        \n Deseja cancelar o processo de dispensação?
                        \n\n Os itens que já foram liberados até aqui não serão perdidos.`,
          hasImage: true,
          textButtonConfirm: "Não",
          textButtonCancel: "Sim"
        },
      });
      dialogRef.afterClosed().subscribe({
        next: (result) => {
          if (!result.confirm)
            this.matDialogRef.close({ checkMedicine: false });
          else {
            return;
          }
        },
        error: (error) => {
          console.log(error);
        }
      });
    }
    else
      this.matDialogRef.close({ checkMedicine: false });
  }

  storageSuggestion() {
    this.verifyStorageService.listMedicineStorage(this.prescriptionMedicineStruct.prescriptionMedicine.idMedicine, null, this.idSector).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.isLoading = false;
        if (response.listStorage) {
          this.listStorage = response.listStorage;
          this.storage = this.listStorage[0];
          this.isValid = true;
        }
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  openBarCodeModal() {
    const dialogRef = this.dialog.open(MedicineBarCodeModalComponent, {
      data: {
        idMedicine: this.prescriptionMedicineStruct.prescriptionMedicine.idMedicine,
        listStorage: this.listStorage,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result && result.barcodeValue) {
          this.barcodeValue = result.barcodeValue;
          this.amountRemaining = result.amountRemaining;
          this.medicinePresentationOther = result.medicine.medicinePresentationOther;
          this.idMedicinePresentationType = result.medicine.idMedicinePresentationType;
          this.model.get('idPresentationType')?.setValue(result.medicine.idMedicinePresentationType);
          if (!this.isObservation) {
            this.model.get('idLocation')?.setValue(result.idLocation);
            this.model.get('idLocation')?.disable();
          }
          else {
            this.idUserPharmacy = result.idUserMove;
          }

          if (result.amountRemaining === 0) {
            this.model.get('quantity')?.setValidators([Validators.required, Validators.min(0.001), estoqueValidator(result.amountRemaining)]);
            this.model.get('quantity')?.markAsTouched();
            this.validated = false;
          }
          else {
            this.model.get('quantity')?.setValidators([Validators.required, Validators.min(0.001), Validators.max(result.amountRemaining)]);
            this.validated = true;
          }
          if (this.prescriptionMedicineStruct.prescriptionMedicine.idPresentation && this.idMedicinePresentationType != this.prescriptionMedicineStruct.prescriptionMedicine.idPresentation)
            this.openConfirmModal();
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  openConfirmModal() {
    const dialogRef = this.dialog.open(PresentationTypeConfirmModalComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirm == false) {
        this.openBarCodeModal();
      }
    });
  }

  populatePresentationType() {
    this.medicinePresentationTypeService.listMedicinePresentationType().subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.isLoading = false;
        this.presentationList = response.listMedicinePresentationType;

        this.presentationTypeDoctor = this.prescriptionMedicineStruct.prescriptionMedicine.idPresentation ? this.prescriptionMedicineStruct.presentationName : "Não informado";
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  populatePharmacyLookups() {
    let request = new LookupsBooleanChoiceRequest();
    request.isToGetMedicineGroupTypeLookup = false;
    request.isToGetMedicineSubgroupLookup = false;
    request.isToGetMedicinePresentationTypeLookup = true;
    request.isToGetMedicineAdministrationTypeLookup = false;
    request.isToGetKitMultiselectLookup = false;
    request.isToGetMeasurementUnitLookup = true;
    request.isToGetDoseToAdministered = true;

    this.lookupService.searchLookupsUsingBooleanRequestFilter(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.presentationList = [];
        if (response.listMedicinePresentationType && response.listMedicinePresentationType.length > 0) {
          this.presentationList = [...response.listMedicinePresentationType];
          this.presentationTypeDoctor = this.prescriptionMedicineStruct.prescriptionMedicine.idPresentation ? this.prescriptionMedicineStruct.presentationName : "Não informado";
        }

        this.measurementUnitList = [];
        if (response.listMeasurementUnit && response.listMeasurementUnit.length > 0)
          this.measurementUnitList = [...response.listMeasurementUnit];

        if (response?.listDoseToAdministered?.length > 0)
          this.listDoseToAdministered = [...response.listDoseToAdministered];
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getAdditionalElementsForDispenssing(listIdKit: number[] = []) {
    this.isLoading = true;
    let body = new AdditionalElementsToKitSearchRequest();
    body.listIdKit = listIdKit;

    if (this.data.isObservation) {
      body.idSector = this.data.idSector;
    }

    if (!listIdKit || listIdKit.length === 0 || (listIdKit.length === 1 && listIdKit.some(x => x === 0 || x === null)))
      return;

    this.kitService.GetAdditionalElementsByIdKit(body).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        if (response.listAdditionalItemForPrescriptionReleaseForm && response.listAdditionalItemForPrescriptionReleaseForm.length > 0)
          this.listAdditionalItemsForRequest = [...response.listAdditionalItemForPrescriptionReleaseForm];

        if (response.listAdditionalMedicinesForPrescriptionReleaseForm && response.listAdditionalMedicinesForPrescriptionReleaseForm.length > 0)
          this.listAdditionalMedicinesForRequest = [...response.listAdditionalMedicinesForPrescriptionReleaseForm];

        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  setLoneliness() {
    if (!this.listItemFields || this.listItemFields?.length == 0)
      return;

    if (this.listItemFields.length == 1)
      this.listItemFields[0].isSingle = true;
    else if (this.listItemFields.length > 1) {
      this.listItemFields.forEach(element => {
        element.isSingle = false;
      });
    }
  }

  openPrescriptionNonDispensationModalFromModal() {
    const dialogRef = this.dialog.open(PrescriptionNonDispensationModalComponent, {
      data: {
        prescription: this.prescriptionMedicineStruct,
        patientName: this.episode.patientName,
      },
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result && result.notDispensed)
          this.matDialogRef.close({ checkMedicine: result.notDispensed, newStatus: result.newStatus });
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  openAdditionalItemsModal() {
    const dialogRef = this.dialog.open(AdditionalItemModalComponent, {
      data: {
        listAdditionalItemsForRequest: this.listAdditionalItemsForRequest,
        listAdditionalMedicinesForRequest: this.listAdditionalMedicinesForRequest,
        listIdKit: this.data.prescription?.listSelectedIdKit ? this.data.prescription?.listSelectedIdKit : [],
        isObservation: this.isObservation,
        idSector: this.idSector
      },
      panelClass: 'prescription-additional-itens',
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result && result.listAdditionalItemsForRequest) {
          this.listAdditionalItemsForRequest = result.listAdditionalItemsForRequest
        }
        if (result && result.listAdditionalMedicinesForRequest) {
          this.listAdditionalMedicinesForRequest = result.listAdditionalMedicinesForRequest
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  get doseToAdministeredName(): string {
    const idDose = this.model?.get('idDoseToAdministered')?.value;

    if (!idDose || !this.listDoseToAdministered) {
      return '';
    }

    const doseItem = this.listDoseToAdministered.find(x => x.idDoseToAdministered === idDose);
    return doseItem ? doseItem.name : '';
  }
}